import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Search, Users, CheckSquare, LogOut, BookMarked, Map, Settings, BookOpen, Globe } from "lucide-react";

const navItems = [
  { to: "/dashboard", icon: LayoutDashboard, label: "Dashboard", testid: "nav-dashboard", end: true },
  { to: "/prospection", icon: Search, label: "Prospection", testid: "nav-prospection" },
  { to: "/prospects", icon: Users, label: "Pipeline CRM", testid: "nav-prospects" },
  { to: "/tasks", icon: CheckSquare, label: "Relances", testid: "nav-tasks" },
  { to: "/templates", icon: BookMarked, label: "Modèles IA", testid: "nav-templates" },
  { to: "/map", icon: Map, label: "Carte", testid: "nav-map" },
  { to: "/settings", icon: Settings, label: "Paramètres", testid: "nav-settings" },
  { to: "/guide", icon: BookOpen, label: "Mode d'emploi", testid: "nav-guide" },
  { to: "/site", icon: Globe, label: "Site public PC UP", testid: "nav-site", external: true },
];

export default function AppLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen flex bg-[#09090b]">
      <aside className="w-64 shrink-0 bg-[#0d0d12] border-r border-slate-800/80 flex flex-col">
        <div className="p-6 border-b border-slate-800/80">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-xl bg-white flex items-center justify-center p-1 shadow-[0_0_20px_rgba(6,182,212,0.15)]">
              <img data-testid="brand-logo" src="/logo-icon.png" alt="PC UP" className="w-full h-full object-contain" />
            </div>
            <div>
              <div data-testid="brand-name" className="font-heading font-extrabold text-slate-100 text-xl leading-none tracking-tight">PC UP</div>
              <div className="text-[10px] italic text-slate-400 mt-1 leading-tight">L'informatique à votre service</div>
            </div>
          </div>
        </div>

        <nav className="flex-1 p-3 space-y-1">
          {navItems.map((it) => it.external ? (
            <a key={it.to} href={it.to} target="_blank" rel="noreferrer" data-testid={it.testid} className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-all text-slate-400 hover:bg-slate-800/60 hover:text-slate-200 border border-transparent">
              <it.icon className="w-4 h-4" strokeWidth={2} />
              <span className="font-medium">{it.label}</span>
            </a>
          ) : (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              data-testid={it.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-all ${
                  isActive
                    ? "bg-cyan-500/10 text-cyan-300 border border-cyan-500/30"
                    : "text-slate-400 hover:bg-slate-800/60 hover:text-slate-200 border border-transparent"
                }`
              }
            >
              <it.icon className="w-4 h-4" strokeWidth={2} />
              <span className="font-medium">{it.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="p-3 border-t border-slate-800/80">
          <div data-testid="company-info" className="px-3 py-2 mb-2 text-[11px] leading-relaxed text-slate-500">
            <div className="text-slate-300 font-medium">Florence Lebouc</div>
            <div>06 60 91 67 64</div>
            <div>contact@pcup.fr</div>
            <div>5 Place Aimé et Marie Geoffroy<br />91390 Morsang-sur-Orge</div>
          </div>
          <div className="px-3 py-2 rounded-lg bg-slate-900/60 border border-slate-800">
            <div data-testid="user-name" className="text-sm font-medium text-slate-200 truncate">{user?.name}</div>
            <div className="text-xs text-slate-500 truncate">{user?.email}</div>
          </div>
          <button
            data-testid="logout-button"
            onClick={() => { logout(); nav("/login"); }}
            className="mt-2 w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-slate-400 hover:bg-rose-500/10 hover:text-rose-300 transition-colors"
          >
            <LogOut className="w-4 h-4" /> Déconnexion
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}
